import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { mq } from "../../Theme";
import { mapColor } from "../textUtils";
var subtitle = function(param) {
    var textColor = param.textColor, theme = param.theme;
    return /*#__PURE__*/ css("font-weight:600;color:", mapColor(theme, textColor), ";font-size:1.313rem;line-height:1.238em;", mq("lg"), "{font-size:", theme.fontSize.md.size, ";font-weight:", theme.fontWeight.heading, ";line-height:1.3rem;}");
};
var SubtitleWrapper = /*#__PURE__*/ styled("div", {
    target: "e1afh08i0"
})(subtitle);
export { subtitle, SubtitleWrapper };
